<template>
  <v-card v-bind="$attrs" :class="classes" class="v-card--material pa-3 v-card--material-stats">
    <div class="d-flex grow flex-wrap">
      <v-sheet
          :class="{'pa-7': !$slots.image }"
          :color="color"
          :max-height="icon ? 90 : undefined"
          :width="inline || icon ? 'auto' : '100%'"
          elevation="6"
          class="text-start v-card--material__heading mb-n6"
          dark
      >
        <slot
            v-if="$slots.heading"
            name="heading"
        />

        <slot
            v-else-if="$slots.image"
            name="image"
        />


        <slot
            v-else-if="$slots.icon"
            name="icon"
        />

        <div
            v-else-if="title"
            class="display-1 font-weight-light"
            v-text="title"
        />


        <div
            v-if="text"
            class="headline font-weight-thin"
            v-text="text"
        />


        <div
            v-if="$slots['after-heading']"
            class="ml-6"
        >
          <slot name="after-heading"/>
        </div>

      </v-sheet>
      <div class="ml-6">
        <slot name="after-heading">
          <div class="ml-auto text-right">
            <div class="body-3 grey--text font-weight-light">
              <span>{{ title }}</span>
              <v-tooltip v-if="tooltip != null" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                      v-bind="attrs"
                      v-on="on"
                      style="top:-2px; position: relative;"
                  >
                       <v-icon class="pl-1 grey--text font-weight-light">mdi-information-outline</v-icon>
                </span>
                </template>
                <span>{{ tooltip }}</span>
              </v-tooltip>
            </div>
            <h3 class="display-2 font-weight-light text--primary">
              {{ value }} <small>{{ smallValue }}</small>
            </h3>
          </div>
        </slot>
      </div>
    </div>
    <slot/>
  </v-card>
</template>

<script>


import Card from "./base/Card";
import RequestIcon from "../views/app/icons/RequestIcon";

export default {
  name: "StatsCard",
  components: {RequestIcon},
  inheritAttrs: false,
  props: {
    ...Card.props,
    icon: {
      type: String,
      required: false,
    },
    footer: {
      type: Boolean,
      default: false,
    },
    subIcon: {
      type: String,
      default: undefined,
    },
    subIconColor: {
      type: String,
      default: undefined,
    },
    subTextColor: {
      type: String,
      default: undefined,
    },
    subText: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: undefined,
    },
    value: {
      type: String,
      default: undefined,
    },
    smallValue: {
      type: String,
      default: undefined,
    },
    color: {
      type: String,
      default: 'success',
    },
    inline: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    classes() {
      return {
        'v-card--material--has-heading': this.hasHeading,
        'v-card--material--hover-reveal': this.hoverReveal,
      }
    },
    hasHeading() {
      return Boolean(this.$slots.heading || this.title || this.icon)
    },
    hasAltHeading() {
      return Boolean(this.$slots.heading || (this.title && this.icon))
    },
  },
}
</script>

<style scoped>

</style>
